module.exports = __webpack_public_path__ + "media/src/assets/save-2f622ce40c7c59e35dab825d71cdf728.svg";